"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Calendar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _2 = require("../..");

var _hooks = require("../../../hooks");

var _utils = require("../../../utils");

var _icons = require("../../../icons");

var _calendarModule = _interopRequireDefault(require("./calendar.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var DAY_NAMES = {
  en: ["M", "T", "W", "T", "F", "S", "S"],
  de: ["M", "D", "M", "D", "F", "S", "S"],
  fr: ["L", "M", "M", "J", "V", "S", "D"]
};
var MONTH_NAMES = {
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  de: ["Jän.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  fr: ["Janv.", "Févr.", "Mars", "Avr.", "Mai", "Juin", "Juil", "Août.", "Sept.", "Oct.", "Nov.", "Déc."]
};

var getDaysInMonth = function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
};

var getFirstDayOfMonth = function getFirstDayOfMonth(year, month) {
  return new Date(year, month, 1).getDay();
};

var isSameDay = function isSameDay(dateA, dateB) {
  if (dateA instanceof Date && dateB instanceof Date) {
    return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate();
  }

  return false;
};

var isBetweenMinMax = function isBetweenMinMax(date, minDate, maxDate) {
  if (date instanceof Date && minDate instanceof Date && maxDate instanceof Date) {
    return date.getTime() >= minDate.getTime() && date.getTime() <= maxDate.getTime();
  }

  return false;
};

var toUTCDate = function toUTCDate(date) {
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
};

var Calendar = function Calendar(_ref) {
  var children = _ref.children,
      activeRanges = _ref.activeRanges;

  var _useLocale = (0, _hooks.useLocale)(),
      locale = _useLocale.locale;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      day = _useState4[0],
      setDay = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      month = _useState6[0],
      setMonth = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      year = _useState8[0],
      setYear = _useState8[1];

  var checkIfInRange = (0, _react.useCallback)(function (date) {
    var dateUTC = toUTCDate(date);

    var ranges = _toConsumableArray(activeRanges);

    var range;

    while (range = ranges.pop()) {
      var startUTC = toUTCDate(range.start);
      var endUTC = toUTCDate(range.end);

      if (isBetweenMinMax(dateUTC, startUTC, endUTC)) {
        return true;
      }
    }

    return false;
  }, [activeRanges]);
  var monthName = (0, _react.useMemo)(function () {
    return (0, _utils.getProperty)(MONTH_NAMES, "".concat(locale, ".").concat(month));
  }, [locale, month]);
  var dayNames = (0, _react.useMemo)(function () {
    var dayNames = (0, _utils.getProperty)(DAY_NAMES, locale) || [];
    return dayNames.map(function (dayName, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        className: _calendarModule.default.day
      }, /*#__PURE__*/_react.default.createElement(_2.Text, {
        size: "sm",
        weight: "semibold"
      }, dayName));
    });
  }, [locale]);
  var dates = (0, _react.useMemo)(function () {
    var daysPerWeek = DAY_NAMES[locale].length;
    var daysCount = getDaysInMonth(year, month);
    var firstDayOfMonth = getFirstDayOfMonth(year, month) || daysPerWeek; // sunday = 0 -> 7, monday = 1 -> 1, ...

    var beforeCount = firstDayOfMonth - 1;
    var totalCount = beforeCount + daysCount;
    var rows = Math.ceil(totalCount / daysPerWeek);
    var afterCount = rows * daysPerWeek - totalCount;
    var beforeDays = Array.from({
      length: beforeCount
    });
    var days = Array.from({
      length: daysCount
    }).map(function (_, index) {
      return index + 1;
    });
    var afterDays = Array.from({
      length: afterCount
    });
    return [].concat(_toConsumableArray(beforeDays), _toConsumableArray(days), _toConsumableArray(afterDays)).map(function (day, index) {
      var currentDate = new Date(year, month, day);
      var todayDate = new Date();
      var isToday = isSameDay(currentDate, todayDate);
      var isActive = checkIfInRange(currentDate);
      var className = [_calendarModule.default.date, isToday ? _calendarModule.default.today : "", isActive ? _calendarModule.default.active : ""].filter(Boolean).join(" ");
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "".concat(year, "-").concat(month, "-").concat(index),
        className: className
      }, /*#__PURE__*/_react.default.createElement(_2.Text, {
        size: "sm"
      }, day));
    });
  }, [locale, year, month, checkIfInRange]);
  var prevMonthHandler = (0, _react.useCallback)(function () {
    return setDate(new Date(year, month - 1, day));
  }, [year, month, day]);
  var nextMonthHandler = (0, _react.useCallback)(function () {
    return setDate(new Date(year, month + 1, day));
  }, [year, month, day]);
  (0, _react.useEffect)(function () {
    if (date === null) {
      return;
    }

    setDay(date.getDate());
    setMonth(date.getMonth());
    setYear(date.getFullYear());
  }, [date]);
  (0, _react.useEffect)(function () {
    return setDate(new Date());
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _calendarModule.default.wrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _calendarModule.default.nav
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: _calendarModule.default.button,
    onClick: prevMonthHandler
  }, /*#__PURE__*/_react.default.createElement(_icons.MinusCircleIcon, {
    className: _calendarModule.default.svg
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _calendarModule.default.current
  }, /*#__PURE__*/_react.default.createElement(_2.Text, {
    weight: "bold",
    transform: "uppercase"
  }, monthName, " ", year)), /*#__PURE__*/_react.default.createElement("button", {
    className: _calendarModule.default.button,
    onClick: nextMonthHandler
  }, /*#__PURE__*/_react.default.createElement(_icons.PlusCircleIcon, {
    className: _calendarModule.default.svg
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _calendarModule.default.body
  }, dayNames, dates), children);
};

exports.Calendar = Calendar;
Calendar.defaultProps = {
  activeRanges: []
};
Calendar.propTypes = {
  activeRanges: _propTypes.default.arrayOf(_propTypes.default.shape({
    start: _propTypes.default.instanceOf(Date).isRequired,
    end: _propTypes.default.instanceOf(Date).isRequired
  }))
};